import apiSDK from '@/services/apiSdk';
import { queryKeys } from '@/store/queryClient';
import { useQuery } from '@tanstack/react-query';
import { PlugPag } from '@inhouse-market/sdk';

export const useGetTotemReport = (params: PlugPag.ReportRequest) => {
    return useQuery({
        queryKey: queryKeys.GET_TOTEM_REPORT(params),
        queryFn: async () => apiSDK.totem.report(params),
        refetchOnWindowFocus: false,
    });
};
